import type { Device, ZklRc } from '@/pages/Device/Device'

export type FetchDevicePageOptions = {
  selectedFilters: Record<string, Record<string, string>>
} & PageOptions
type CancelledPageResult = {
  rowCount: null
  data: null
}

export type FotaJobPageFilters = {
  page: number
  pageSize: number
  sortBy: string
  sortDir?: 'asc' | 'desc' | null
  searchTerm?: string
  state?: string[]
}
type SuccessfulPageResult<T> = {
  rowCount: number
  data: T
}
export type PageOptions = {
  pageIndex: number
  pageSize: number
  sortBy: { id: string; desc?: boolean }[]
  globalFilter: string
}

export type PageResult<T> = CancelledPageResult | SuccessfulPageResult<T>

export type JobRowData = {
  id: number
  uid: string
  serial: string
  label: string
  is_online: boolean
  created_by: string
  version: string
  state: string
  created_at: string
  updated_at: string
  FirmwarePath: string
  error_code: string
}

export type FOTAJobCancelResponse = JobRowData & {
  successful: boolean
}

export type FOTAJobCompleteResponse = JobRowData & {
  successful: boolean
}

export type FetchDeviceFilters = {
  inService: boolean
  durationTestStatus: number[]
  transferStatus: number[]
  selfTest: number
}

export const DefaultFetchDeviceFilters: FetchDeviceFilters = {
  inService: true,
  durationTestStatus: [],
  transferStatus: [],
  selfTest: 0,
}

export type Failure = 1
export type Success = 0

export type FailedTransfer = {
  status: Failure
  reason: string
  concerns?: TransferConcerns
}

export type SuccessfulTransfer = {
  status: Success
  data: unknown
}

export type TransferConcerns = {
  errors?: {
    code: number
    descr: string
  }[]
  warnings?: {
    code: number
    descr: string
  }[]
}

// Utility type: At least one property of T must be provided
export type RequireAtLeastOne<T> = {
  [K in keyof T]-?: Required<Pick<T, K>> & Partial<Omit<T, K>>
}[keyof T]

// Definition of PatchDevice
export type PatchDevice = RequireAtLeastOne<
  Required<
    Pick<
      Device,
      | 'serial'
      | 'country'
      | 'productionDate'
      | 'productionNr'
      | 'writtenOff'
      | 'pcbSerials'
    > &
      Pick<ZklRc, 'mustHaveAftc'> & {
        deviceRoleCode?: string
      }
  >
>

export type Transfer = FailedTransfer | SuccessfulTransfer

export const Status: { IN_PROGRESS: -1; SUCCESS: Success; FAILURE: Failure } = {
  IN_PROGRESS: -1,
  SUCCESS: 0,
  FAILURE: 1,
}

export const TransferState: {
  DOMESTIC: 0
  IN_PROGRESS: 1
  FOREIGN: 2
} = {
  DOMESTIC: 0,
  IN_PROGRESS: 1,
  FOREIGN: 2,
}
export const DurationTestStatus: {
  DurationTestNotStarted: 0
  DurationTestInProgress: 1
  DurationTestVerify: 2
  DurationTestCanceled: 3
  DurationTestSkipped: 4
  DurationTestCompleted: 5
  DurationTestIgnored: 6
} = {
  DurationTestNotStarted: 0,
  DurationTestInProgress: 1,
  DurationTestVerify: 2,
  DurationTestCanceled: 3,
  DurationTestSkipped: 4,
  DurationTestCompleted: 5,
  DurationTestIgnored: 6,
}

export interface PcbPasswordResponse {
  password: string
}
